import { render, staticRenderFns } from "./CommissionUploadDetail.vue?vue&type=template&id=16b06945&"
import script from "./CommissionUploadDetail.vue?vue&type=script&lang=js&"
export * from "./CommissionUploadDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports